'use client';

import React from 'react';

const MOBILE_BREAKPOINT = 1024;

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(
    undefined,
  );

  React.useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    };
    
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const onChange = () => checkMobile();
    
    // Initial check
    checkMobile();
    
    // Listen for changes
    mql.addEventListener('change', onChange);
    
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return !!isMobile;
}
